<template>
  <div class="application size-chart" v-if="data && data.title">
    <p class="size-chart__title">
      {{ $t('application.size_chart') }}
    </p>
    <a type="text" @click="open" class="size-chart__link">
      <i class="size-chart__icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28.83"
          height="16"
          viewBox="0 0 28.83 16"
        >
          <g
            transform="translate(40.292 86.243) rotate(90)"
          >
            <g
              transform="translate(-86.243 11.463)"
              fill="none"
              stroke="#242d33"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
            >
              <rect width="16" height="28.83" rx="4" stroke="none" />
              <rect x="1" y="1" width="14" height="26.83" rx="3" fill="none" />
            </g>
            <line
              y1="0.002"
              x2="3.391"
              transform="translate(-84.552 21.074)"
              fill="none"
              stroke="#242d33"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <line
              x2="6.781"
              transform="translate(-84.553 25.877)"
              fill="none"
              stroke="#242d33"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <line
              y1="0.002"
              x2="3.391"
              transform="translate(-84.554 16.554)"
              fill="none"
              stroke="#242d33"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <line
              y1="0.002"
              x2="3.391"
              transform="translate(-84.552 35.199)"
              fill="none"
              stroke="#242d33"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
            />
            <line
              y1="0.002"
              x2="3.391"
              transform="translate(-84.554 30.679)"
              fill="none"
              stroke="#242d33"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="2"
            />
          </g>
        </svg>
      </i>
      <span>{{ data.title }}</span>
    </a>

    <el-dialog
      width="600px"
      :title="data.title"
      :visible="visible"
      :show-close="true"
      :center="false"
      :before-close="close"
      :lock-scroll="true"
      :append-to-body="true"
      custom-class="size-chart__dialog"
    >
      <div v-for="item in data.config" :key="item.id">
        <div class="size-chart__table" v-if="item.type === 'table'">
          <v-size-chart-table :data="item" :options="item.options || {}" />
        </div>

        <div
          v-if="item.type === 'image'"
          class="size-chart__image"
          ref="imageWrapper"
        >
          <v-lazy-img v-if="item.image" class="lazyload chart-img__img" :data-url="item.image.url"   :src="item.image.thumbnail"></v-lazy-img>
          <div v-else class="chart-img__default-img">
            <img :src="defaultImage" alt="" />
          </div>
        </div>
        <div v-if="item.type === 'text'" class="size-chart__text">
          <div v-html="item.body_html" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VSizeChartTable from "./SizeChartTable";
import { imageWidthHeight } from "../../../lib/util.js";
import defaultImage from "@/images/applications/sizeChart/default_img.png";

export default {
  name: "SizeChart",
  components: {
    VSizeChartTable,
  },
  props: {
    product_id: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      visible: false,
      data: null,
      defaultImage,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    // 加载数据
    async fetch() {
      const { dispatch } = this.$store;
      try {
        const res = await dispatch({
          type: 'sizeChart/fetch',
          productId: this.product_id,
        })

        const { status, data } = res || {}

        if (status === 200) {
          this.data = data
        } else {
          console.error(data?.message || res?.statusText || 'error request')
        }
      } catch (error) {
        const data = error.response?.data
        // 错误消息弹窗
        if (data?.errors) {
          Vue.prototype.$message.error(Object.values(data.errors)[0]?.[0])
        } else if (data?.message) {
          Vue.prototype.$message.error(data.message)
        }
      }
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    // 计算图片比例
    imgHeight(url) {
      const dom = this.$refs.imageWrapper;
      const widthHeight = imageWidthHeight(url);
      if (widthHeight) {
        const width =
          this.$refs.imageWrapper && this.$refs.imageWrapper.clientWidth;
        return (widthHeight.height / widthHeight.width) * width;
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.size-chart {
  &__dialog {
    max-width: calc(100vw - 30px);
    margin: 0 auto;
    text-align: left;
    margin-top: 15vh;
    .el-dialog {
      &__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &__body {
        max-height: 70vh;
        overflow-y: auto;
      }
    }
  }
  &__text {
    p {
      margin-top: 0;
      margin-bottom: 0;
    }
    // 代理样式
    p {
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
    }
    hr {
      overflow: hidden;
      border-style: inset;
      border-width: 1px;
    }
    ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
      li {
        display: list-item;
        text-align: -webkit-match-parent;
        list-style: inherit;
      }
    }
    ol {
      display: block;
      list-style-type: decimal;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
      li {
        display: list-item;
        text-align: -webkit-match-parent;
        list-style: inherit;
      }
    }
    a {
      text-decoration: underline;
    }
  }
}
</style>

<style lang="scss" scoped>
.size-chart {
  text-align: left;
  &__title {
    font-size: 15px;
    margin-bottom: 16px;
    text-transform: capitalize;
  }
  &__link {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
    border: 1px solid #222323;
    display: inline-flex;
    align-items: center;
    font-size: 15px;
    min-height: 40px;
    padding: 7px 16px;
    max-width: 100%;
    line-height: normal;
    i, span {
      margin: 0 6px;
    }
    span {
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
  &__icon {
    display: flex;
    align-items: center;
  }
  &__table {
    margin: 10px 0;
  }
  &__image {
    max-height: 500px;
    display: flex;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    .chart-img {
      &__img {
        width: 100%;
        height: auto;
      }
      &__default-img {
        height: 140px;
        width: 100%;
        display: flex;
        background: #f5f5f7;
        justify-content: center;
        align-items: center;
        img {
          height: 80px;
          width: auto;
        }
      }
    }
  }
  &__text {
    margin: 10px 0;
    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
}
</style>